/*** IMPORTS FROM imports-loader ***/
var define = false;

export function bundleAccordion() {
  var rows = document.querySelectorAll('.bundle-row');
  var bundleList = document.querySelector('.bundle-list');

  // --- Accordion toggle ---
  function toggleAccordion(row) {
    var toggle = row.querySelector('.bundle-row__toggle');
    var accordionId = toggle.getAttribute('aria-controls');
    var accordion = document.getElementById(accordionId);
    if (!accordion) return;

    var isOpen = toggle.getAttribute('aria-expanded') === 'true';

    // Close all other accordions
    rows.forEach(function (otherRow) {
      if (otherRow !== row) {
        var otherToggle = otherRow.querySelector('.bundle-row__toggle');
        var otherId = otherToggle.getAttribute('aria-controls');
        var otherAccordion = document.getElementById(otherId);
        if (otherAccordion && otherToggle.getAttribute('aria-expanded') === 'true') {
          otherToggle.setAttribute('aria-expanded', 'false');
          otherAccordion.style.maxHeight = null;
          otherRow.classList.remove('bundle-row--open');
        }
      }
    });

    // Toggle current
    if (isOpen) {
      toggle.setAttribute('aria-expanded', 'false');
      accordion.style.maxHeight = null;
      row.classList.remove('bundle-row--open');
    } else {
      toggle.setAttribute('aria-expanded', 'true');
      accordion.style.maxHeight = accordion.scrollHeight + 'px';
      row.classList.add('bundle-row--open');
    }
  }

  // Make entire row clickable, except cart button area
  rows.forEach(function (row) {
    row.addEventListener('click', function (e) {
      // Don't toggle if clicking inside the cart area or the bottom price/button area
      if (e.target.closest('.bundle-row__cart') || e.target.closest('.bundle-row__cart-btn')) return;
      toggleAccordion(row);
    });
  });

  // --- Disable bundles until table is in cart ---
  var tableProductId = bundleList ? bundleList.getAttribute('data-table-product-id') : null;
  if (!tableProductId) return;

  function setDisabled(disabled) {
    var cartBtns = document.querySelectorAll('.bundle-row__cart-btn');
    cartBtns.forEach(function (btn) {
      btn.disabled = disabled;
    });
    var caption = document.querySelector('.bundle-requires-table');
    if (caption) {
      caption.style.display = disabled ? '' : 'none';
    }
  }

  function checkCart() {
    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var tableInCart = cart.items.some(function (item) {
          return String(item.product_id) === String(tableProductId);
        });
        setDisabled(!tableInCart);
      })
      .catch(function () {
        setDisabled(false);
      });
  }

  // Check on load
  checkCart();

  // Re-check when cart updates
  if (typeof subscribe === 'function') {
    subscribe('cart-update', function () {
      checkCart();
    });
  }
}

